import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { AppRoutingModule } from '../app-routing.module'
import { ViewModuleComponent } from './view.component'
import { LoginPageComponent } from './login-page/login-page.component'
import { AboutPageComponent } from './about-page/about-page.component'
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component'
import { ReportFilterComponent } from '../components/report-filter/report-filter.component'
import { ComponentsModule } from '../components/components.module'
import { ContactPageComponent } from './contact-page/contact-page.component'
import { RegisterPageComponent } from './register-page/register-page.component'
import { RegisterMasterAgentComponent } from './register-master-agent/register-master-agent.component'
import { RegisterFinancialInstitutionComponent } from './register-financial-institution/register-financial-institution.component'
import { ReportPageComponent } from './report-page/report-page.component'
import { ForgotPasswordPageComponent } from './forgot-password-page/forgot-password-page.component'
import { ConfirmPasswordPageComponent } from './confirm-password-page/confirm-password-page.component'
import { MasteragentComponent } from './masteragent/masteragent.component'
import { AdminRegisterMasteragentComponent } from './admin-register-masteragent/admin-register-masteragent.component'
import { DevtpartnerComponent } from './devtpartner/devtpartner.component'
import { AdminRegisterDevtpartnerComponent } from './admin-register-devtpartner/admin-register-devtpartner.component'
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OWL_DATE_TIME_FORMATS,
} from 'ng-pick-datetime'
import { AdminListComponent } from './admin-list/admin-list.component'
import { NgxPaginationModule } from 'ngx-pagination'
import { NewAdminComponent } from './new-admin/new-admin.component'
import { OrderModule } from 'ngx-order-pipe'
import { ChangePasswordFormComponent } from './change-password/change-password.component'
import { EditAdminComponent } from './edit-admin/edit-admin.component'
import { AdminUsersLogComponent } from './admin-users-log/admin-users-log.component'
import { GovernmentComponent } from './government/government.component'
import { AdminRegisterGovernmentComponent } from './admin-register-government/admin-register-government.component'
import { AppManagementDashboardComponent } from './_app-management/app-management-dashboard/app-management-dashboard.component'
import { ChartsModule } from 'ng2-charts'
import { DiseasesComponent } from './_app-management/diseases/diseases.component'
import { PestsComponent } from './_app-management/pests/pests.component'
import { AgronomicalComponent } from './_app-management/agronomical/agronomical.component'
import { NgxChartsModule } from '@swimlane/ngx-charts'
import { NgxPrintModule } from 'ngx-print'
import { QuillModule } from 'ngx-quill'
import { VillageagentsComponent } from './villageagents/villageagents.component'
import { FarmersComponent } from './farmers/farmers.component'
import { FinancialinstitutionComponent } from './financialinstitution/financialinstitution.component'
import { PageNotFoundComponent } from './page-not-found/page-not-found.component'
import { PaymentTypePipe } from '../_shared/utils/payment-type.pipe'
import { MarketInfoComponent } from './_app-management/market-info/market-info.component'
import { SendNotificationsComponent } from './_app-management/send-notifications/send-notifications.component'
//import { TruncateTextPipe } from '../truncate-text.pipe';
import { TableModule } from 'primeng/table'
import { MultiSelectModule } from 'primeng/multiselect'
import { CalendarModule } from 'primeng/calendar'
import { InputTextModule } from 'primeng/inputtext'
import { DigitOnlyModule } from '@uiowa/digit-only'
import { SmartDiagnosisDiseaseComponent } from './_app-management/smart-diagnosis-disease/smart-diagnosis-disease.component'
import { SmartDiagnosisPestComponent } from './_app-management/smart-diagnosis-pest/smart-diagnosis-pest.component'
import { CropinfoHeadingsComponent } from './_app-management/cropinfo-headings/cropinfo-headings.component'
import { DropdownModule } from 'primeng/dropdown'
import { TabViewModule } from 'primeng/tabview'
import { CodeHighlighterModule } from 'primeng/codehighlighter'
import { AllCropDataComponent } from './_app-management/all-crop-data/all-crop-data.component'
import { CropDetailComponent } from './_app-management/crop-detail/crop-detail.component'
import { OrdersCommunicationService } from '../_shared/services/orders.service'
import { IndiaManagementDashboardComponent } from './_app-management/india-management-dashboard/india-management-dashboard.component'
import { NewMarketInfoDesignComponent } from './_app-management/new-market-info-design/new-market-info-design.component'
import { ContactsComponent } from './_app-management/contacts/contacts.component'
import { FinancialLiteracyComponent } from './_app-management/financial-literacy/financial-literacy.component'
import { FinancialLitTopicsComponent } from './_app-management/financial-lit-topics/financial-lit-topics.component'
import { UsageModule } from './usage/usage.module'
import { VideosComponent } from './_app-management/videos/videos.component'
import { AnimalDetailComponent } from './_app-management/animal-detail/animal-detail.component'
import { AnimalComponent } from './_app-management/animal/animal.component'
import { EzyagricUsersComponent } from './usage/ezyagric-users/ezyagric-users.component';
import { PushNotificationsComponent } from './push-notifications/push-notifications.component'

export const MY_NATIVE_FORMATS = {
  fullPickerInput: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  datePickerInput: { year: 'numeric', month: 'numeric', day: 'numeric' },
  timePickerInput: { hour: 'numeric', minute: 'numeric' },
  monthYearLabel: { year: 'numeric', month: 'short' },
  dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
  monthYearA11yLabel: { year: 'numeric', month: 'long' },
}
@NgModule({
  declarations: [
    ViewModuleComponent,
    LoginPageComponent,
    AboutPageComponent,
    AdminDashboardComponent,
    ChangePasswordFormComponent,
    AdminUsersLogComponent,
    ReportFilterComponent,
    ContactPageComponent,
    RegisterPageComponent,
    RegisterMasterAgentComponent,
    RegisterFinancialInstitutionComponent,
    ReportPageComponent,
    ForgotPasswordPageComponent,
    ConfirmPasswordPageComponent,
    MasteragentComponent,
    AdminRegisterMasteragentComponent,
    DevtpartnerComponent,
    AdminRegisterDevtpartnerComponent,
    AdminListComponent,
    NewAdminComponent,
    EditAdminComponent,
    GovernmentComponent,
    AdminRegisterGovernmentComponent,
    AppManagementDashboardComponent,
    DiseasesComponent,
    PestsComponent,
    AgronomicalComponent,
    VillageagentsComponent,
    FarmersComponent,
    FinancialinstitutionComponent,
    ReportPageComponent,
    PageNotFoundComponent,
    PaymentTypePipe,
    MarketInfoComponent,
    SendNotificationsComponent,
    SmartDiagnosisDiseaseComponent,
    SmartDiagnosisPestComponent,
    CropinfoHeadingsComponent,
    AllCropDataComponent,
    CropDetailComponent,
    // India Dashboard
    IndiaManagementDashboardComponent,
    NewMarketInfoDesignComponent,
    ContactsComponent,
    FinancialLiteracyComponent,
    FinancialLitTopicsComponent,
    VideosComponent,
    AnimalDetailComponent,
    AnimalComponent,
    EzyagricUsersComponent,
    PushNotificationsComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    ComponentsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxPaginationModule,
    OrderModule,
    ChartsModule,
    NgxChartsModule,
    NgxPrintModule,
    QuillModule,
    TableModule,
    MultiSelectModule,
    CalendarModule,
    InputTextModule,
    DigitOnlyModule,
    DropdownModule,
    TabViewModule,
    CodeHighlighterModule,
    UsageModule,
  ],
  providers: [
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_NATIVE_FORMATS },
    OrdersCommunicationService,
  ],
  exports: [CommonModule, FormsModule, ReactiveFormsModule, OrderModule],
})
export class ViewModule {}
